import styled from 'styled-components'

export const StyledVideoContainer = styled.div`
  margin: 0 auto;
  width: fit-content;
  display: flex;
  align-items: center;
  flex-direction: column;
`
export const StyledVideo = styled.video`
  margin-top: 1rem;
  margin-bottom: 2rem;
  max-width: 55rem;
  box-shadow: 3px 3px 3px black;

  @media (orientation:portrait) {
    flex-direction: column;
    align-items: center;
    display: flex;
    max-width: 100%;
  }

  ::cue {
    font-family: "Georgia", sans-serif;
    font-size: 28px;
  }
  @media (max-width: 1024px) {
    ::cue {
      font-size: 22px;
    }
  }
`
